import { atomWithStorage } from 'jotai/utils'

/** Controls whether public stories are shown on the landing page catalog. */
export const showPublicStoriesAtom = atomWithStorage(
  'bw_showPublicStories',
  null,
  undefined,
  { getOnInit: true },
)
